import styled from 'styled-components';

export const TableBottomRow = styled.div.attrs({
  className: 'row col-12 mx-0 px-4'
})`
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const TableTopRow = styled.div.attrs({
  className: 'row col-12 mx-0 px-0'
})`
  height: 80px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    height: max-content;
    flex-direction: column;
  }
`

export const TableMainWrapper = styled.div.attrs(props => {
  return {
    className: props.containerClassName ? props.containerClassName : 'col-12 px-3'
  }
})`
  font-size: 12px;
  ${({minWidth}) => (minWidth ? `min-width: ${minWidth}` : '')}
`

export const PageWrapper = styled.div`
  overflow-y: scroll;
`

export const LeftSection = styled.span`
  height: 36px;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    margin: 10px 0px;
  }
`

export const RightSection = styled.span`
  height: 36px;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const SizeWrapper = styled.span`
  height: 36px;
  flex: 0.5;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    flex: 1;
    margin-bottom: 10px;
  }
`

export const AltWrapper = styled.span`
  height: 36px;
  flex: 0.5;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const SearchWrapper = styled.span`
  height: 36px;
  flex: ${({isInline}) => isInline ? 1 : 0.5};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  
  @media (max-width: 768px) {
    flex: 1;
    margin-bottom: 10px;
  }
`

export const StyledSpan = styled.span.attrs({
  className: 'react-bootstrap-table-pagination-total'
})`
  height: 34px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  color: ${({ theme }) => theme.blackAbs};
`
